export default __webpack_public_path__ + "static/media/customerService.f1b4b7f8.svg";